export default {
  NavigationBar() {
    return import('@/components/portal/NavigationBar')
  },
  NewsOne() {
    return import('@/components/portal/NewsOne')
  },
  NewsTwo() {
    return import('@/components/portal/NewsTwo')
  },
  NewsThree() {
    return import('@/components/portal/NewsThree')
  },
  NewsFour() {
    return import('@/components/portal/NewsFour')
  },
  BayWindow() {
    return import('@/components/portal/BayWindow')
  },
  URLHref() {
    return import('@/components/portal/URLHref')
  },
  URLIframe() {
    return import('@/components/portal/URLIframe')
  },
  HorizontalImageWall() {
    return import('@/components/portal/HorizontalImageWall')
  },
  VerticalImageWall() {
    return import('@/components/portal/VerticalImageWall')
  },
  Carousel() {
    return import('@/components/portal/Carousel')
  },
  ImageNews() {
    return import('@/components/portal/ImageNews')
  },
  ImageNewsTwo() {
    return import('@/components/portal/ImageNewsTwo')
  },
  NewsVideo() {
    return import('@/components/portal/NewsVideo')
  },
  BannerLong() {
    return import('@/components/portal/BannerLong')
  },
  NewsVideoTwo() {
    return import('@/components/portal/NewsVideoTwo')
  },
  NewsHtml() {
    return import('@/components/portal/NewsHtml')
  },
  Breadcrumb() {
    return import('@/components/portal/Breadcrumb')
  },
}
